export default () => {
    $('div[id^="contact-modal-"]').each( function(i) {
        let ele = $(this)
		const id = $(this).attr('data-id');
        const seconds = $(this).attr('data-seconds');

        setTimeout(function() { 
            $('body').addClass('overflow-hidden')
            ele.show(400)
        }, seconds);

		$('#contact-close-'+id).on("click", function() {
            $('body').removeClass('overflow-hidden')
			ele.hide(400)
		})
	});
}